/** Upper bound for one request; matches the repository picker's page size. */
export const MAX_LINK_REPOSITORY_DOCUMENTS = 20;

export interface LinkRepositoryDocumentsRequest {
  /** Warranty document (repository) ids, never storage item ids. */
  warrantyDocumentIds: string[];
}

export enum LinkRepositoryDocumentStatus {
  LINKED = 'linked',
  ALREADY_LINKED = 'alreadyLinked',
  /** Not found, not the customer's, removed, or outside the claim's warranty/asset - deliberately indistinguishable. */
  UNAVAILABLE = 'unavailable',
  FAILED = 'failed',
}

export interface LinkRepositoryDocumentResult {
  warrantyDocumentId: string;
  status: LinkRepositoryDocumentStatus;
  /** The claim document (storage item) id; only for linked and alreadyLinked. */
  documentId?: string;
}

export interface LinkRepositoryDocumentsResponse {
  /** One result per unique requested id, in request order. */
  results: LinkRepositoryDocumentResult[];
}
